var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element el-map",class:{ 'can-change': _vm.is_editable }},[_c('div',{staticClass:"map",attrs:{"id":"document-map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }